import React, { memo } from "react";

const MenuToggle = memo(({ expanded, onToggle }) => (
  <button
    type="button"
    className="vh-menu-toggle hide-show-menu hide_show_menu_btn"
    aria-expanded={expanded}
    aria-controls="header-main-nav"
    aria-label={expanded ? "Close navigation menu" : "Open navigation menu"}
    onClick={onToggle}
  >
    <span className="hide-show-menu-icon" aria-hidden="true" />
  </button>
));

export default MenuToggle; 